module.exports = __webpack_public_path__ + "img/GH-kyujin-top-023.439a5b1d.webp";